import axios from "axios";

const deleteUserRole = async (token, tourId, userId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/users/${userId}`;
  try {
    const response = await axios.delete(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};

export default deleteUserRole;
